import { ComposedSheet } from './ComposedSheet'
import { ReactNode, forwardRef } from 'react'
import { TooltipWrapper } from './TooltipWrapper'

export const SheetWithFormComponent = forwardRef<
  React.ElementRef<typeof ComposedSheet>,
  {
    children: ReactNode
    title?: string
    description?: string
    trigger?: ReactNode
    triggerTooltip?: string
    wide?: boolean
    isOpen?: boolean
    onOpenChange?: (open: boolean) => void
  }
>(({ children, title, description, trigger, triggerTooltip, wide = true, isOpen, onOpenChange }, ref) => {
  const sheet = (
    <ComposedSheet
      ref={ref}
      wide={wide}
      title={title}
      description={description}
      trigger={triggerTooltip ? undefined : trigger}
      isOpen={isOpen}
      onOpenChange={onOpenChange}
    >
      {children}
    </ComposedSheet>
  )

  if (triggerTooltip)
    return (
      <TooltipWrapper tooltip={triggerTooltip} wrapTrigger triggerComponent={sheet}>
        {trigger}
      </TooltipWrapper>
    )

  return sheet
})

SheetWithFormComponent.displayName = 'SheetWithFormComponent'
